import { render, staticRenderFns } from "./PricingPlansComponent.vue?vue&type=template&id=5056b8fc&scoped=true"
import script from "./PricingPlansComponent.vue?vue&type=script&lang=js"
export * from "./PricingPlansComponent.vue?vue&type=script&lang=js"
import style0 from "./PricingPlansComponent.vue?vue&type=style&index=0&id=5056b8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5056b8fc",
  null
  
)

export default component.exports